<template>
    <div :class="['toolbar-root', { 'is-vertical': vertical }]">
        <span v-show="isAuthenticated && (userRole && userRole.toLowerCase() !== 'secretaria' && userRole.toLowerCase() !== 'medico')">
            <v-btn text :to="'/turnos'" color="primary" class="mx-1">
                <v-icon left>mdi-calendar</v-icon>
                Turnos
            </v-btn>
            <v-btn text :to="'/turnospaciente'" color="primary" class="mx-1">
                <v-icon left>mdi-format-list-bulleted</v-icon>
                Mis Turnos
            </v-btn>
            <v-btn text :to="'/mis-estudios'" color="primary" class="mx-1">
                <v-icon left>mdi-file-download</v-icon>
                Mis Estudios
            </v-btn>
            <!-- TEMPORAL: deshabilitado hasta nuevo aviso. Para reactivar, poner MI_HISTORIA_CLINICA_HABILITADA en true -->
            <v-btn v-if="userRole === 'paciente'" text :disabled="!MI_HISTORIA_CLINICA_HABILITADA" :to="{ name: 'mi-historia-clinica' }" color="primary" class="mx-1">
                <v-icon left>mdi-file-document-outline</v-icon>
                Mi Historia Clínica
            </v-btn>
        </span>
        <span v-show="userRole && userRole.toLowerCase() === 'medico' && isAuthenticated">
            <v-btn text :to="'/agenda'" color="primary" class="mx-1">
                <v-icon left>mdi-calendar-month</v-icon>
                Agenda
            </v-btn>
            <v-btn text :to="'/events'" color="primary" class="mx-1">
                <v-icon left>mdi-calendar-clock</v-icon>
                Citas
            </v-btn>
            <v-btn text :to="{ path: '/pacienteList', query: { perfil: 'medico' } }" color="primary" class="mx-1">
                <v-icon left>mdi-account-group</v-icon>
                Pacientes
            </v-btn>
        </span>
        <span v-show="userRole && userRole.toLowerCase() === 'secretaria' && isAuthenticated">
            <v-btn text :to="'/turnos-secretaria'" color="primary" class="mx-1">
                <v-icon left>mdi-calendar-multiple</v-icon>
                Citas
            </v-btn>
            <v-btn text :to="{ path: '/pacienteList', query: { perfil: 'secretaria' } }" color="primary" class="mx-1">
                <v-icon left>mdi-account-group</v-icon>
                Pacientes
            </v-btn>
            <v-menu 
                offset-y 
                close-on-content-click
                transition="slide-y-transition"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                        text 
                        v-bind="attrs" 
                        v-on="on" 
                        color="primary" 
                        class="mx-1"
                    >
                        <v-icon left>mdi-doctor</v-icon>
                        Profesionales
                        <v-icon right>mdi-chevron-down</v-icon>
                    </v-btn>
                </template>
                <v-list dense>
                    <v-list-item @click="navigate('profesionales-abm')" link>
                        <v-list-item-icon>
                            <v-icon>mdi-account-cog</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>ABM Profesionales</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="navigate('workcalendar')" link>
                        <v-list-item-icon>
                            <v-icon>mdi-calendar-plus</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Crear Agenda</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="navigate('workcalendardelete')" link>
                        <v-list-item-icon>
                            <v-icon>mdi-calendar-remove</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Eliminar Agenda</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </span>
        <SuperuserMenu v-if="isAuthenticated && isSuperuser" />
        <span v-show="isAuthenticated">
            <v-btn v-if="!viendoComoOtro" text :to="'/editaccount'" color="primary" class="mx-1">
                <v-icon left>mdi-account-cog</v-icon>
                Cuenta
            </v-btn>
            <v-btn text @click="logout" color="error" class="mx-1">
                <v-icon left>mdi-logout</v-icon>
                Cerrar Sesión
            </v-btn>
        </span>
        <span v-show="!isAuthenticated">
            <v-btn text :to="'/nuevoturno'" color="primary" class="mx-1">
                <v-icon left>mdi-calendar-plus</v-icon>
                Turnos
            </v-btn>
            <v-btn text :to="'/about'" color="primary" class="mx-1">
                <v-icon left>mdi-map-marker</v-icon>
                Contacto
            </v-btn>
            <!--v-btn outlined :to="'/signup'" color="primary" class="mx-1">
                <v-icon left>mdi-account-plus</v-icon>
                Crear Usuario
            </v-btn-->
            <v-btn color="primary" :to="'/login'" class="mx-1">
                <v-icon left>mdi-login</v-icon>
                Iniciar Sesión
            </v-btn>

        </span>
        
    </div>
</template>

<script>
import { logout as logoutAuth } from '@/services/auth';
import SuperuserMenu from './SuperuserMenu.vue';

// Deshabilita temporalmente el botón "Mi Historia Clínica" del paciente
const MI_HISTORIA_CLINICA_HABILITADA = false;

export default {
    name: 'Toolbar',
    components: { SuperuserMenu },
        props: {
                // Cuando true, muestra los botones en columna (para drawer móvil)
                vertical: { type: Boolean, default: false }
        },
    data: function() {
        return {
            MI_HISTORIA_CLINICA_HABILITADA,
            attrs : '',
            links: [
                { icon: 'home', text: 'Home', route: '/'},
                { icon: 'contacts', text: 'About', route: '/about'},
            ]
        }
    },
    computed: {
        userRole() {
            // Superusuario sin perfil elegido: arranca en la vista de secretaría
            if (this.isSuperuser && !this.$store.state.view_as) {
                return 'secretaria';
            }
            // Obtener roles del user_profile (es un array)
            const userProfile = this.$store.state.user_profile;
            if (userProfile && (userProfile.role || (userProfile.roles && userProfile.roles.length > 0))) {
                // Usar el primer rol del array
                let role = userProfile.role || userProfile.roles[0];
                role = role.toLowerCase();
                
                // Mapear roles del Auth Service a roles locales
                const roleMap = {
                    'secretary': 'secretaria',
                    'doctor': 'medico',
                    'patient': 'paciente',
                    'admin': 'admin'  // Por si hay rol admin
                };
                
                const originalRole = role;
                role = roleMap[role] || role;
                return role;
            }
            
            // Fallback al viejo credentials.role si existe
            const legacyRole = this.$store.state.credentials.role;
            if (legacyRole) {
                return legacyRole;
            }
            
            return null;
        },
        isAuthenticated() {
            return this.$store.state.authenticated;
        },
        isSuperuser() {
            return this.$store.getters.isSuperuser;
        },
        viendoComoOtro() {
            return !!this.$store.getters.viewAsEmail;
        }
    },
    methods: {
        navigate(route) {
            this.$router.push({ name: route });
        },
        async logout() {
            try {
                await logoutAuth(this.$store);
                this.$router.push('/login');
            } catch (error) {
                console.error('Error en logout:', error);
                // Aunque falle, redirigir al login
                this.$router.push('/login');
            }
        }
    }
}
</script>

<style scoped>
/* Layout vertical para usar dentro del drawer en móvil */
.toolbar-root.is-vertical {
    display: flex;
    flex-direction: column;
    padding: 8px 6px;
}

/* Asegura disposición en columna y ancho completo */
.toolbar-root.is-vertical span {
    display: block;
}

.toolbar-root.is-vertical .v-btn {
    width: 100%;
    justify-content: flex-start;
    margin: 6px 0;
}

.toolbar-root.is-vertical .v-icon {
    margin-right: 8px;
}

/* Asegurar que los menús desplegables tengan z-index alto */
.v-menu__content {
    z-index: 9999 !important;
}
</style>